import React, { Fragment } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import numeral from "numeral";
import Select from "../../../shared/components/forms/Select";

function DateSelect({ value, onChange, name, onFocus, ...props }) {
  const separator = '-';

  function renderOptions(from, to) {
    let options = [];

    for(let i = from; i <= to; i++) {
      options.push( { text: i, value: numeral(i).format('00') } )
    }
    return options;
  }

  function renderDayOptions() {
    return renderOptions(1, 31);
  }

  function renderYearOptions() {
    return renderOptions(props.startYear, props.endYear);
  }

  function renderMonthOptions() {
    return moment.months().map((month, i) => {
      return (
        {text: month, value: numeral(i + 1).format('00')}
      )
    })
  }

  function getDay() {
    if(value === null) { return "" }

    const day = value.split(separator)[2];
    return day;
  }

  function getMonth() {
    if(value === null) { return "" }

    const month = value.split(separator)[1];
    return month;
  }

  function getYear() {
    if(value === null) { return "" }

    const year = value.split(separator)[0];
    return year;
  }

  function constructDate(year, month, day) {
    return [year, month, day].join(separator);
  }

  function handleChange(e) {
    if(!onChange) { return }

    switch(e.target.name) {
      case 'day':
        value = constructDate(getYear(), getMonth(), e.target.value);
        break;
      case 'month':
        value = constructDate(getYear(), e.target.value, getDay());
        break;
      case 'year':
        value = constructDate(e.target.value, getMonth(), getDay());
        break;
      default:
        value = null;
        break;
    }
    onChange({ target: { name: name, value: value }});
  }

  function renderError() {
   return props.error && <span className= 'byline -danger'> {props.error} </span>;
  }

  const {
    yearPlaceholder,
    monthPlaceholder,
    dayPlaceholder,
    //endYear,
    //startYear
  } = props;

  return (
    <Fragment>
      {renderError()}
      <div className="ds-formGroup _date">
        <Select
          id="month"
          name="month"
          options={renderMonthOptions()}
          includeBlank={monthPlaceholder}
          value={getMonth()}
          onChange={handleChange}
          onFocus={onFocus}
        />
        <Select
          id="day"
          name="day"
          options={renderDayOptions()}
          includeBlank={dayPlaceholder}
          value={getDay()}
          onChange={handleChange}
          onFocus={onFocus}
        />
        <Select
          id="year"
          name="year"
          options={renderYearOptions()}
          includeBlank={yearPlaceholder}
          value={getYear()}
          onChange={handleChange}
          onFocus={onFocus}
        />
      </div>
    </Fragment>
  );
}

DateSelect.propTypes = {
  value: PropTypes.string,
  startYear: PropTypes.number,
  endYear: PropTypes.number
};

DateSelect.defaultProps = {
  startYear: moment().subtract(99, 'years').year(),
  endYear: moment().subtract(18, 'years').year(),
  onFocus: () => {},
  dayPlaceholder: "Day",
  monthPlaceholder: "Month",
  yearPlaceholder: "Year",
};

export default DateSelect;



// WEBPACK FOOTER //
// ./src/features/shared/components/forms/DateSelect.js